/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
 import React from "react";
import TabPanel from "./TabsCreateForm";
import {Typography } from '@material-ui/core';
import ThemeControls from "../Component/AllThemesControl";
import { FormJSONCreateContext } from "../Component/FormJSONCreateContext";

//Tab Stepper 
import TabStepper from './TabStepper';
import TabFormPart from './TabFormPart';
import TabFormPartwithConfirm from './TabFormPartwithConfirm';
import TabFormRow from './TabFormRow';
import MultiForm from './MultiForm';

function FormSection(props) {
  const {useStyles} = ThemeControls;
  const {contextJson} = React.useContext(FormJSONCreateContext);
  const classes = useStyles();

  return (
  <>
    { ( contextJson.xioFEConfig && contextJson.xioFEConfig.TabStyle &&  contextJson.xioFEConfig.TabStyle==="steps")?<TabStepper contextClass={props.contextClasses}/>:
      ( contextJson.xioFEConfig && contextJson.xioFEConfig.TabStyle &&  contextJson.xioFEConfig.TabStyle==="cardStyle")?<TabFormPart contextClass={props.contextClasses}/>:
      ( contextJson.xioFEConfig && contextJson.xioFEConfig.TabStyle &&  contextJson.xioFEConfig.TabStyle==="cardStyleConfirm")?<TabFormPartwithConfirm contextClass={props.contextClasses}/>:
      ( contextJson.xioFEConfig && contextJson.xioFEConfig.TabStyle &&  contextJson.xioFEConfig.TabStyle==="multiForm")?<MultiForm contextClass={props.contextClasses}/>:
      ( contextJson.xioFEConfig && contextJson.xioFEConfig.TabStyle &&  contextJson.xioFEConfig.TabStyle==="TabFormRow")?<TabFormRow contextClass={props.contextClasses} formType={contextJson.xioFEConfig.TabStyle}/>:
      <TabPanel contextClass={props.contextClasses}/>}   
  </>
);
}

export default FormSection; 
